import { z } from "zod";

/* ===========================================================================
 * US-E7.F2-0050 — Member Vote Expense (@UC0067/@UC0068)
 * POST /v1/expenses/:id/votes + GET /v1/expenses/:id/vote-status.
 *
 * PO chốt: phiếu MUTABLE TRƯỚC deadline (đổi choice = update); sau deadline/đóng → khóa.
 * Auto-finalize khi đủ tỉ lệ sớm hoặc deadline → passed post EXPENSE | failed rejected.
 * ========================================================================= */

export const VOTE_CHOICE = {
  YES: "yes",
  NO: "no",
  ABSTAIN: "abstain",
} as const;

export type VoteChoice = (typeof VOTE_CHOICE)[keyof typeof VOTE_CHOICE];

export const voteChoiceSchema = z.enum([
  VOTE_CHOICE.YES,
  VOTE_CHOICE.NO,
  VOTE_CHOICE.ABSTAIN,
]);

export const VOTE_CLOSED_MESSAGE =
  "Phiên biểu quyết đã đóng — không thể bỏ phiếu.";

/** Body vote. choice yes/no/abstain. */
export const castVoteRequestSchema = z
  .object({
    choice: voteChoiceSchema,
  })
  .strict();

export type CastVoteRequest = z.infer<typeof castVoteRequestSchema>;

/** Bộ đếm phiếu (dùng cho cast response + vote-status). */
export const voteTallySchema = z
  .object({
    yes: z.number().int().nonnegative(),
    no: z.number().int().nonnegative(),
    abstain: z.number().int().nonnegative(),
    totalEligible: z.number().int().nonnegative(),
  })
  .strict();

export type VoteTally = z.infer<typeof voteTallySchema>;

/** Consensus status sau cast (open nếu chưa chốt; passed/failed/expired nếu finalize). */
export const consensusStatusSchema = z.enum([
  "open",
  "passed",
  "failed",
  "expired",
]);

export const castVoteResponseSchema = z
  .object({
    expenseId: z.string().uuid(),
    consensusId: z.string().uuid(),
    myVote: voteChoiceSchema,
    tally: voteTallySchema,
    consensusStatus: consensusStatusSchema,
    /** txId EXPENSE nếu vote này làm consensus passed + post ledger; null nếu chưa chốt. */
    ledgerTxId: z.string().uuid().nullable(),
  })
  .strict();

export type CastVoteResponse = z.infer<typeof castVoteResponseSchema>;

export const voteStatusResponseSchema = z
  .object({
    expenseId: z.string().uuid(),
    consensusId: z.string().uuid(),
    consensusStatus: consensusStatusSchema,
    tally: voteTallySchema,
    /** Lựa chọn của caller | null nếu chưa vote. */
    myVote: voteChoiceSchema.nullable(),
    deadline: z.string().datetime().nullable(),
  })
  .strict();

export type VoteStatusResponse = z.infer<typeof voteStatusResponseSchema>;
